import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from './../index';
import { Button, Row, Col, Radio, Form, Input, Select } from 'antd';
import Helper from "./../../../extra/helper";
import Ithoigian from './../../../../src/assets/pvi-benhhiemngheo/ithoigian.svg';
// import './../../../../extra/phuc_binh_an/style.css';
import DatePicker from "../modalnotification/DatePicker";
import moment from "moment";
import MdSelect from "./../modalnotification/modalSelect";


const Question = () => {
  const { goStep, Back, toltalFees } = useContext(AuthContext);
  const { Option } = Select;
  const [datePicker, setDatePicker] = useState({});
  const [formData, setFormData] = useState({});
  const [form] = Form.useForm();
  const formRef = React.createRef();
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    let ListPackageInsu = JSON.parse(localStorage.getItem('dataIsu'));

    // code cũ
    // if (ListPackageInsu) {
    //   setFormData({...ListPackageInsu, "endDate": ListPackageInsu?.beginDate? moment(new Date(ListPackageInsu?.beginDate?.replace(/(\d+[/])(\d+[/])/, "$2$1"))).subtract(1,"days").add(ListPackageInsu?.yearsOfInsurance, "years").format("DD/MM/YYYY"):''});
    //   form.setFieldsValue({...ListPackageInsu, "endDate": ListPackageInsu?.beginDate? moment(new Date(ListPackageInsu?.beginDate?.replace(/(\d+[/])(\d+[/])/, "$2$1"))).subtract(1,"days").add(ListPackageInsu?.yearsOfInsurance, "years").format("DD/MM/YYYY"):''}|| {});
    // }
    if (ListPackageInsu) {
      setFormData({...ListPackageInsu, beginDate: undefined});
      form.setFieldsValue({...ListPackageInsu, beginDate: undefined, endDate: undefined});
    }
    window.scrollTo(0, 0);
  }, []);

  const onFinish = (val) => {
    let ListPackageInsu = JSON.parse(localStorage.getItem('dataIsu'));
    form
      .validateFields()
      .then(async (values) => {
        goStep(4);
        localStorage.setItem('dataIsu',
          JSON.stringify({
            ...ListPackageInsu,
            ...values,
            packedIndex: +values.package.slice(-1)
            // fee: formData.listPackageInsu[formData.package - 1].value
          })
        )
        setFormData(values || {});
      })
      .catch((err) => {
        // console.error('err:', err);
      });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const onChangForm = ({ data, name }) => {
    setFormData({
      ...formData,
      [name]: data,
    });
  };

  const setFee = (value) => {
    setFormData({
      ...formData,
      "fee": value,
    });
    // console.log(formData);
  };

  const css = {
    input: { color: '#3A3A3A', zIndex: 1, fontSize: 15, boxShadow: 'none', padding: '10px 35px', borderRadius: 9, width: '100%' },
    titleInput: { color: '#646D69', marginBottom: 3 },
    FormItemsHolder: { width: "100%", borderRadius: 8, margin: '5px 0px', padding: 0 },
    iconInput: { width: 20, margin: '15px 10px', position: 'absolute', zIndex: 2 }
  }

  return (
    <div style={{ fontSize: 14, background: '#EDEFFA' }}>
      <MdSelect setFee={setFee} form={form} data={formData?.listPackageInsu} handleCancel={handleCancel} isModalVisible={isModalVisible} />
      {
        datePicker.open &&
        <DatePicker
          onConfirm={(data) => {
            form.setFieldsValue({ "beginDate": data, "endDate": moment(new Date(data.replace(/(\d+[/])(\d+[/])/, "$2$1"))).subtract(1,"days").add(formData?.yearsOfInsurance, "years").format("DD/MM/YYYY") })
            onChangForm({ data: data, name: "beginDate" });
          }}
          min={moment().add(1, "days").toDate()}
          visible={datePicker.open}
          close={() => {
            setDatePicker({ ...datePicker, open: false });
          }}
          value={formData.beginDate}
        />
      }
      <Form
        ref={formRef}
        form={form}
        onFinish={onFinish}
        name="Serach_account"
        scrollToFirstError
      >
        <Row>
          <Col style={{ borderBottom: '1px solid #828EE1', background: '#ffffff' }} xs={24}>
            <div style={{ fontWeight: 600, padding: '2% 3%' }}>Gói bảo hiểm</div>
          </Col>
          <Col style={{ background: '#ffffff' }} xs={24}>
            <div style={{ padding: '2% 3%' }}>
              <Form.Item
                name="package"
                rules={[{
                  required: true,
                  message: 'Vui lòng chọn và nhập thông tin',
                }]}
                re
                style={css.FormItemsHolder}
              >
                <Select
                  className="custom-select-antd-no-padding-disa"
                  // showSearch
                  disabled
                  autoComplete="off"
                  // allowClear={true}
                  onClick={() => setIsModalVisible(true)}
                  placeholder="Chọn gói bảo hiểm"
                >
                  {(formData?.listPackageInsu || []).map((data, i) => (
                    <Option key={data.id} value={data.id}>{data?.title} - {data.benefit}</Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          </Col>
          <Col style={{ background: '#ffffff' }} xs={24}>
            <div style={{ fontWeight: 500, padding: '0px 3% 2% 3%', display: 'flex', justifyContent: 'space-between' }}>
              <span>Thời hạn bảo hiểm</span>
              <span>
                {formData?.yearsOfInsurance} năm
              </span>
            </div>
          </Col>
          <Col style={{ marginBottom: 8, background: '#ffffff' }} xs={24}>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0px 3% 2% 3%' }}>
              <div style={{ width: '50%', marginRight: 5 }}>
                <div style={{ padding: '0px', position: 'relative' }}>
                  <div style={css.titleInput}>Ngày hiệu lực</div>
                  <img style={css.iconInput} src={Ithoigian} alt="quyen loi" />
                  <Form.Item
                    name="beginDate"
                    rules={[{
                      required: true,
                      message: 'Vui lòng chọn và nhập thông tin',
                    }]}
                    style={css.FormItemsHolder}
                  >
                    <Input autoComplete="off"
                      readOnly
                      style={css.input}
                      placeholder='DD/MM/YYYY'
                      onClick={() => {
                        setDatePicker({ ...datePicker, open: true });
                      }}
                    />
                  </Form.Item>
                </div>
              </div>
              <div style={{ width: '50%', marginLeft: 5 }}>
                <div style={{ padding: '0px', position: 'relative' }}>
                  <div style={css.titleInput}>Ngày kết thúc</div>
                  <img style={css.iconInput} src={Ithoigian} alt="quyen loi" />
                  <Form.Item
                    name="endDate"
                    rules={[{
                      required: true,
                      message: 'Vui lòng chọn và nhập thông tin',
                    }]}
                    style={css.FormItemsHolder}
                  >
                    <Input autoComplete="off"
                      style={css.input}
                      placeholder='DD/MM/YYYY'
                      disabled
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
          </Col>
          <Col style={{ background: '#ffffff', borderBottom: '1px solid #828EE1' }} xs={24}>
            <div style={{ padding: '2% 3%' }}>
              <div style={{ fontWeight: 500 }}>Câu hỏi thẩm định</div>
              <div>
                <span style={{ color: '#3141B4' }}>Người được bảo hiểm</span> có bị mắc 1 trong những bệnh dưới đây không?
              </div>
            </div>
          </Col>
          <Col style={{ background: '#ffffff' }} xs={24}>
            <div style={{ padding: '2% 3% 0px 3%' }}>
              1. Bạn đã từng mắc phải, hoặc được thông báo rằng bạn mắc phải,
              hoặc đang trong quá trình kiểm tra/ điều trị một trong các bệnh sau: bệnh viêm gan siêu vi B/C, ung thư, khối u, u nang, phát triển ung thư biểu mô tại chỗ của bất kỳ loại ung thư nào, đau tim, rối loạn nhịp tim, phình mạch não, hẹp động mạch cảnh, nhồi máu não, xuất huyết não,
              xuất huyết dưới màng nhện, tắc mạch máu não, huyết khối trong mạch máu não không?
            </div>
            <div style={{ padding: '2% 3%' }}>
              <Form.Item
                name="question1"
                rules={[{
                  required: true,
                  message: 'Vui lòng chọn và nhập thông tin',
                },
                {
                  message: 'Bạn không đạt điều kiện tham gia bảo hiểm.',
                  pattern: /[2-3]/
                }
                ]}
                style={css.FormItemsHolder}
              >
                <Radio.Group style={{ width: '100%' }}>
                  <Row>
                    <Col xs={12} xl={4} >
                      <Radio value={2}>Không</Radio>
                    </Col>
                    <Col xs={12} xl={4}>
                      <Radio value={1}>Có</Radio>
                    </Col>
                  </Row>
                </Radio.Group>
              </Form.Item>
            </div>
          </Col>
          <Col style={{ background: '#ffffff' }} xs={24}>
            <div style={{ padding: '0px 3%' }}>
              2. Bạn có hút hơn 20 điếu thuốc một ngày không?
            </div>
            <div style={{ padding: '0px 3%' }}>
              <Form.Item
                name="question2"
                rules={[{
                  required: true,
                  message: 'Vui lòng chọn và nhập thông tin'
                },
                {
                  message: 'Bạn không đạt điều kiện tham gia bảo hiểm.',
                  pattern: /[2-3]/
                }
                ]}
                style={css.FormItemsHolder}
              >
                <Radio.Group style={{ width: '100%' }}>
                  <Row>
                    <Col xs={12} xl={4} >
                      <Radio value={2}>Không</Radio>
                    </Col>
                    <Col xs={12} xl={4}>
                      <Radio value={1}>Có</Radio>
                    </Col>
                  </Row>
                </Radio.Group>
              </Form.Item>
            </div>
          </Col>
          <Col style={{ background: '#ffffff' }} xs={24}>
            <div style={{ padding: '2% 3% 0px 3%' }}>
              3. Bạn có mắc triệu chứng nào sau đây trong thời gian 3 tháng gần đây nhất và kéo dài liên tục hơn 1 tuần hay không?<br />
              <ul style={{ margin: 0 }}>
                <li>Mệt mỏi; hoặc</li>
                <li>Giảm cân không giải thích được; hoặc</li>
                <li>Nổi hạch lớn; hoặc</li>
                <li>Xuất hiện mảng da không giống với khu vực da xung quanh?</li>
                <li>Đau ngực, hoặc</li>
                <li>Rối loạn nhịp tim; hoặc tê, liệt, yếu cục bộ, khó phát âm, không nói được, nuốt khó,
                  suy giảm thị lực, khó đi lại, run, suy giảm trí nhớ, mê sảng?
                </li>
              </ul>
            </div>
            <div style={{ padding: '0px 3%' }}>
              <Form.Item
                name="question3"
                rules={[{
                  required: true,
                  message: 'Vui lòng chọn và nhập thông tin'
                },
                {
                  message: 'Bạn không đạt điều kiện tham gia bảo hiểm.',
                  pattern: /[2-3]/
                }
                ]}
                style={css.FormItemsHolder}
              >
                <Radio.Group style={{ width: '100%' }}>
                  <Row>
                    <Col xs={12} xl={4} >
                      <Radio value={2}>Không</Radio>
                    </Col>
                    <Col xs={12} xl={4}>
                      <Radio value={1}>Có</Radio>
                    </Col>
                  </Row>
                </Radio.Group>
              </Form.Item>
            </div>
          </Col>
          <Col style={{ background: '#ffffff' }} xs={24}>
            <div style={{ padding: '2% 3% 0px 3%' }}>
              4. Bạn đã từng hoặc được đề xuất nên phẫu thuật, kiểm tra hoặc điều trị (*) hoặc đã nằm viện trong 7 ngày trở lên trong vòng 12 tháng qua hay không?
              (*) Điều trị trong những trường hợp sau đây có thể được bỏ qua: cảm lạnh thông
              thường hoặc cảm cúm, mang thai và sinh mổ không biến chứng, ngừa thai, cao huyết áp,
              tăng mỡ máu, tiểu đường, tiêm chủng hoặc chấn thương mà bạn đã hoàn toàn hồi phục.
            </div>
            <div style={{ padding: '0px 3%' }}>
              <Form.Item
                name="question4"
                rules={[{
                  required: true,
                  message: 'Vui lòng chọn và nhập thông tin'
                },
                {
                  message: 'Bạn không đạt điều kiện tham gia bảo hiểm.',
                  pattern: /[2-3]/
                }
                ]}
                style={css.FormItemsHolder}
              >
                <Radio.Group style={{ width: '100%' }}>
                  <Row>
                    <Col xs={12} xl={4} >
                      <Radio value={2}>Không</Radio>
                    </Col>
                    <Col xs={12} xl={4}>
                      <Radio value={1}>Có</Radio>
                    </Col>
                  </Row>
                </Radio.Group>
              </Form.Item>
            </div>
          </Col>
          <Col style={{ background: '#ffffff', marginBottom: 130 }} xs={24}>
            <div style={{ padding: '2% 3% 0px 3%' }}>
              5. Bạn có 2 hoặc nhiều hơn các thành viên trực hệ trong gia đình (cha mẹ hoặc anh, chị, em),
              đã được chẩn đoán bị ung thư hoặc bị đau tim hoặc đột quỵ trước tuổi 60 hay không?
            </div>
            <div style={{ padding: '0px 3%' }}>
              <Form.Item
                name="question5"
                rules={[{
                  required: true,
                  message: 'Vui lòng chọn và nhập thông tin'
                },
                {
                  message: 'Bạn không đạt điều kiện tham gia bảo hiểm.',
                  pattern: /[2-3]/
                }
                ]}
                style={css.FormItemsHolder}
              >
                <Radio.Group style={{ width: '100%' }}>
                  <Row>
                    <Col xs={12} xl={4} >
                      <Radio value={2}>Không</Radio>
                    </Col>
                    <Col xs={12} xl={4}>
                      <Radio value={1}>Có</Radio>
                    </Col>
                  </Row>
                </Radio.Group>
              </Form.Item>
            </div>
          </Col>
          <div style={{ borderRadius: '16px 16px 0px 0px', justifyContent: 'center', padding: '16px 18px 20px 18px', boxShadow: '0px -4px 8px rgba(0, 0, 0, 0.1)', position: 'fixed', bottom: 0, width: '100%', background: '#ffffff', maxWidth: 800}}>
            <div style={{display:'flex', justifyContent:'space-between'}}>
              <Button onClick={() => { Back() }} size="large" style={{ fontSize: 14, background: '#fff', color: '#2A3790', width: '48%', textAlign: 'center', borderRadius: 8, fontWeight: 700, height: 45 }}>
                Quay lại
              </Button>
              <Button htmlType="submit" size="large" style={{ fontSize: 14, background: '#2A3790', color: '#ffffff', width: '48%', textAlign: 'center', borderRadius: 8, fontWeight: 700, height: 45 }}>
                Tiếp tục
              </Button>
            </div>
          </div>
        </Row>
      </Form>
    </div >
  );
};

export default Question;
